export class TaskUpdated {
  constructor(
    readonly id: string,
    readonly updateTriggers: string[],
  ) {}
}
